import { Outlet } from 'react-router-dom'
import { HeadPerfilLogo } from '../../components/HeadPerfilLogo'
import { Container } from './styles'

export default function UsersPage() {
  return (
    <Container>
      <HeadPerfilLogo />
      <div>
        <Outlet />
      </div>
    </Container>
  )
}
